/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Send({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M15.809.107a.5.5 0 0 1 .181.491l-3 15a.5.5 0 0 1-.767.318l-12-8a.5.5 0 0 1 .066-.87l15-7a.5.5 0 0 1 .52.06ZM1.517 7.577l10.64 7.093L14.815 1.37 1.517 7.577Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="m4.946 10.346 10.2-10.2.707.708L5.8 10.907v3.29l1.828-2.031.744.668-2.7 3A.5.5 0 0 1 4.8 15.5v-4.8a.5.5 0 0 1 .146-.354Z" clipRule="evenodd" /></svg>;
}
;